import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableHead: {
    backgroundColor: theme.palette.grey[100],
  },
}))

export default useStyles
